var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReplay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 15,
  fill: "none",
  viewBox: "0 0 14 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.772 13.173a.55.55 0 0 1 .55-.953 5.45 5.45 0 1 0-1.995-7.445l-.028.043 1.65-.308a.55.55 0 1 1 .203 1.08l-2.458.46A1.05 1.05 0 0 1 .47 5.212L.01 2.754a.55.55 0 0 1 1.082-.202l.306 1.634a6.55 6.55 0 1 1 2.375 8.987M1.54 4.954l.007.005-.006.001z",
  clipRule: "evenodd"
})));
export { SvgReplay as ReactComponent };